export class CellSelectedInfoDto {
  field: string;
  dataItem: any;
  selectByFieldName?: any;

  constructor(init: Readonly<CellSelectedInfoDto>) {
    Object.assign(this, init);
  }
}
